/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import * as _redux from "./redux_config";
import store, {persistor} from "./redux_config/store";
import App from "./app/App";
import "./index.scss"; // Standard version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";

import {MetronicLayoutProvider, MetronicSplashScreenProvider, MetronicSubheaderProvider} from "./_metronic/layout";
import "./i18n/index";
import "./_metronic/_assets/sass/fonts/index.scss";
import TagManager from "react-gtm-module";

const {PUBLIC_URL, REACT_APP_GAPP_ID} = process.env;

_redux.setupAxios(axios, store);

if (REACT_APP_GAPP_ID) {
    const tagManagerArgs = {
        gtmId: REACT_APP_GAPP_ID,
        dataLayerName: "PageDataLayer",
    };

    TagManager.initialize(tagManagerArgs);
}
ReactDOM.hydrate(
    <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
            <MetronicSplashScreenProvider>
                <App store={store} persistor={persistor} basename={PUBLIC_URL} />
            </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
    </MetronicLayoutProvider>,
    document.getElementById("root")
);
